import React from 'react';
import ProjectSideSection from './components/ProjectSideSection/ProjectSideSection.js';
import airterra from './assets/img/sides/airterra.png';
import email from './assets/img/sides/email.png';
import aspecta from './assets/img/sides/aspecta.png';
import motion from './assets/img/sides/motion.png';
import IgniX from './assets/img/sides/IgniX.png';
import video from './assets/img/spirit/display.mp4';

import FG01 from './assets/img/sides/FG01.png';
import FG02 from './assets/img/sides/FG02.png';
import FG03 from './assets/img/sides/FG03.png';
import FG04 from './assets/img/sides/FG04.png';
const Side = (props) => {
	const controls = [
		{ 
	    	title: 'Factory Grind',
			category: 'Branding | AIGC',
			description: 'A brand concept turning an abandoned factory into a skatepark, blending risograph visuals, graffiti energy, and skate culture.',
			images: [FG02,FG04,FG03,FG01],
		},
		{ 
	    	title: 'IgniX',
			category: 'Branding | Pitch Deck Design',
			description: '',
			images: [IgniX],
		},
	    { 
	    	title: 'Email Design & Development (2022)',
			category: '',
			description: 'Created a design system for email marketing from scratch. Developed 30+ responsive emails using enterprise ESP tools (Salesforce Marketing Cloud) and front-end coding.',
			images: [email],
		},
	    { 
	    	title: 'Aspecta (2022)',
			category: 'UI/UX Design | Design System',
			description: '',
			images: [aspecta],
		},
		{ 
	    	title: 'Airterra (2021)',
			category: 'Pitch Deck Design',
			description: '',
			images: [airterra],
		},
		{ 
	    	title: 'Spirits In The Sky (2021)',
			category: 'Branding | Motion Graphics',
			description: '',
			images: [],
		}

	];
	return (
	<div className="">
		<div className="project-box grid grid-gap-xs">
			<div className="col-12 flex flex-center">
				{/*s*/}</div>
    	</div>
		<div className="grid flex-width-80 grid-gap-xs" style={{"margin-top": "4em"}}>

		{controls.map(project => (
            <ProjectSideSection 
            	key = {project.title} 
                title={project.title} 
                category={project.category} 
                description={project.description}
                images = {project.images}
            />
        ))}
        		<div className="col-xl-12 col-md-12 col-xs-12 col-12">
		    		<div className="flex flex-center" style={{padding: '2em', backgroundColor: '#0a1f48',backgroundImage: `url(${motion})`,backgroundSize: 'cover',}}>
			    		<video controls style={{maxHeight: '500px', backgroundColor: '#0a1f48'}}>
							<source src={video} type="video/mp4" />
						</video>
		    		</div>
		    	</div>
        </div>
	</div>
)}
export default Side;